import * as contentState from '@mna/content-client/state'
import * as geolocationState from './geolocation'
import * as triageState from './triage'
import * as symptomState from './symptom'
import * as RelatrdSymptomState from './relatedsymptom'
import * as questionState from './question'
import * as azureState from './azure'
import * as errorModalState from './errorModal'

export const createState = () => ({
})

export const actions = {
}

export const states = [
    contentState,
    geolocationState,
    triageState,
    symptomState,
    RelatrdSymptomState,
    azureState,
    errorModalState,
    questionState
]
